import ImageWrapper from "@/components/ImageComponent/ImageWrapper";
import InputTextComponent from "@/components/InputComponent/InputTextComponent";
import MultiSelectFieldset from "@/components/InputComponent/MultiSelectComponent";
import InputNumberComponent from "@/components/InputComponent/InputNumberComponent";
import InputDateComponent from "@/components/InputComponent/InputDateComponent";
import InputFileComponent from "@/components/InputComponent/InputFileComponent";
import SelectFieldset from "@/components/InputComponent/SelectComponent";
import InputTextAreaComponent from "@/components/InputComponent/InputTextAreaComponent";


const BlogModalComponent = (props) => {

    const {isOpen, onClose, data, formData, onInputChange, onFormSubmit, validForm } = props;
    const handleOutsideClick = (event) => {
        if (event.target.id === "modal-overlay") {
            onClose();
        }
    };
    if (!isOpen) return null;
    return (
        <div id="modal-overlay" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" onClick={handleOutsideClick}>
            <div className="relative bg-white w-full max-w-lg md:max-w-2xl lg:max-w-3xl rounded-lg shadow-lg p-6">
                {/* Close Button */}
                <button
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    ✖
                </button>

                {/* Logo */}
                <div className="flex justify-center">
                    <div className="w-48 h-24" onClick={() => router.push("/")}>
                        <ImageWrapper src="/icons/book-my-pooja.svg" className="object-fit"/>
                    </div>
                </div>

                {/* Form */}
                <div className="flex flex-col w-full">
                    <header className="flex justify-between items-center border-b pb-4">
                        <h3 className="font-semibold text-lg"></h3>
                    </header>

                    {/* Fields */}
                    <div className="overflow-y-auto max-h-[60vh] scrollbar border-b mt-4">
                        <section className="flex flex-col gap-3 p-4">
                            {Object.keys(data).map((key) => {
                                const componentProps = {
                                    data: data[key],
                                    value: formData[key].value,
                                    onInputChange: onInputChange,
                                };
                                switch (data[key].type) {
                                    case "select":
                                        return <SelectFieldset key={key} {...componentProps} />;
                                    case "multi-select":
                                        return <MultiSelectFieldset key={key} {...componentProps} />;
                                    case "text":
                                        return <InputTextComponent key={key} {...componentProps} />;
                                    case "number":
                                        return <InputNumberComponent key={key} {...componentProps} />;
                                    case "date":
                                        return <InputDateComponent key={key} {...componentProps} />;
                                    case "file":
                                        return <InputFileComponent key={key} {...componentProps} />;
                                    case "textarea":
                                        return <InputTextAreaComponent key={key} {...componentProps} />;
                                    default:
                                        return null;
                                }
                            })}
                        </section>
                    </div>

                    {/* Footer */}
                    <div className="text-center text-[10px] py-4 text-Default">

                        {/* Submit Button */}
                        <button
                            disabled={!validForm}
                            type="submit"
                            className={`flex items-center justify-center w-full p-4 rounded-lg text-sm tracking-wider leading-5 mt-4 ${
                                !validForm
                                    ? "bg-gray-300 text-Default border border-HeaderQuote cursor-not-allowed"
                                    : "bg-BluntRed text-white hover:bg-HoverModalButtonColor"
                            }`}
                            onClick={onFormSubmit}
                        >
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogModalComponent;
